module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2353"
    }
  }, [_c('b', [_vm._v("DEDICATED TO ")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "RevelationRevealed_0003_001",
      "id": "d14e93",
      "src": "images/RevelationRevealed_0003_001.jpg"
    }
  })]), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e2423"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DR. DAVID D. ALLEN, ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e2473"
    }
  }, [_vm._v("who, upon my conversion to Christianity, opened my mind, eyes, and heart to prophetical truth as a professor at Detroit Bible College (now William Tyndale College), . . . and to ")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e2613"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GREG HARRELL, ")])]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d7e2703"
    }
  }, [_vm._v("whose expertise as a writer was tremendously helpful"), _c('br'), _vm._v(" in editing this work, and to ")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e2783"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("REBECCA (SHELTON) KILGUS, ")])]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d7e2863"
    }
  }, [_vm._v("my niece, whose untiring efforts in preparing the final manuscript are deeply appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d7e2983s"
    }
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d7e2983"
    }
  }, [_vm._v("—Dr. Jack Van Impe ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94fa213a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Impe_ISBN9781418517243_epub_c3_r1.vue
// module id = 63
// module chunks = 0